/**
 * Wrapper no-op-safe em cima do `gtag.js` cru carregado em `public/index.html`.
 *
 * ÚNICO ponto do frontend autorizado a tocar em `window.gtag`. Se o snippet
 * não carregou (adblock, SSR, ambiente de teste, rede caindo), a função
 * simplesmente não faz nada: nunca lança e nunca loga em produção — medição
 * jamais pode quebrar navegação ou cadastro.
 */

/**
 * Envia um evento ao GA4.
 *
 * @param {string} name nome do evento (usar `EVENTS` de `constants.js`).
 * @param {Record<string, string|number>} [params] parâmetros já filtrados
 *   pela allowlist do evento.
 * @returns {boolean} true se o evento foi entregue ao gtag.
 */
export function sendEvent(name, params) {
  try {
    if (typeof name !== "string" || name.length === 0) return false;
    if (typeof window === "undefined") return false;
    if (typeof window.gtag !== "function") return false;

    window.gtag("event", name, params || {});
    return true;
  } catch (_err) {
    // Falha de medição é sempre silenciosa.
    return false;
  }
}

export default sendEvent;
